export const sanitize = (value: string) =>
  value
    .replace(/\s+/g, ' ')
    .replace(/^[=@\-\s]+/, '')
    .trim();
